// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","526":"pages-DebugPage","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"b60ba86c8b8a13bd8d1f","526":"05112aecdc38d96fb933","748":"ef8c40f4d2d761b7d785","777":"61dd42600f47ef24fc01"}[chunkId] + ".js";
};